import { createContext, useContext } from "react";
import type { StockMovement } from "../types/stock-movement.types";

export interface StockMovementOverviewContextType {
  stockMovement: StockMovement | null;
  refetch: () => Promise<void>;
}

const StockMovementOverviewContext =
  createContext<StockMovementOverviewContextType | null>(null);

export function useStockMovementOverview() {
  const context = useContext(StockMovementOverviewContext);
  if (!context) {
    throw new Error(
      "useStockMovementOverview must be used within StockMovementOverviewContext.Provider",
    );
  }
  return context;
}

export default StockMovementOverviewContext;
